module.exports = __webpack_public_path__ + "static/media/laporan_8355.8ef20eaf.png";